// extracted by mini-css-extract-plugin
export default {"primaryColor":"#354760","white":"#fff","container":"styles_container__GjBan","clickable":"styles_clickable__0s1WC"};